module.exports = function() {
  return new Worker(__webpack_public_path__ + "2cfe7978eb476c5beda7.worker.js");
};